import makeApiCall from "../master/axiosIndex";

const workRequestApis = {
  getWorkRequestList: (params: any) =>
    makeApiCall({
      url: `/work-request/list`,
      method: "get",
      params,
    }),
  getPendingApprovalsWorkRequest: (params: any) =>
    makeApiCall({
      url: `/work-request/pending-approvals`,
      method: "get",
      params,
    }),
  getWorkRequestById: (workRequestId: any) =>
    makeApiCall({
      url: `/work-request/id/${workRequestId}`,
      method: "get",
    }),
  createWorkRequest: (data: any) =>
    makeApiCall({
      url: `/work-request/create`,
      method: "post",
      data,
    }),
  updateWorkRequest: (data: any) =>
    makeApiCall({
      url: `/work-request/update`,
      method: "put",
      data,
    }),
  approveWorkRequest: (data: any) =>
    makeApiCall({
      url: `/work-request/approve`,
      method: "post",
      data,
    }),
  rejectWorkRequest: (data: any) =>
    makeApiCall({
      url: `/work-request/reject`,
      method: "post",
      data,
    }),
  taskListByActivityId: (params: any) =>
    makeApiCall({
      url: `/task/list`,
      method: "get",
      params,
    }),
};

export default workRequestApis;
